export const formatNumber = number => number.toLocaleString().replace(/,/g, ' ')
